/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addGroup } from '../fn/group/add-group';
import { AddGroup$Params } from '../fn/group/add-group';
import { SuccessfulActionResponse as DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/CustomResponses/successful-action-response';
import { SuccessfulResponse as DigiworkMaitreDApiConfigurationModelSuccessfulResponse } from '../models/Digiwork/MaitreD/Api/Configuration/Model/successful-response';
import { EnumTypesDto as DigiworkMaitreDPosDtoEnumTypesEnumTypesDto } from '../models/Digiwork/MaitreD/Pos/DTO/EnumTypes/enum-types-dto';
import { CanTableBeFreeDto as DigiworkMaitreDPosDtoGroupCanTableBeFreeDto } from '../models/Digiwork/MaitreD/Pos/DTO/Group/can-table-be-free-dto';
import { GroupDto as DigiworkMaitreDPosDtoGroupGroupDto } from '../models/Digiwork/MaitreD/Pos/DTO/Group/group-dto';
import { GroupsDto as DigiworkMaitreDPosDtoGroupGroupsDto } from '../models/Digiwork/MaitreD/Pos/DTO/Group/groups-dto';
import { freeTable } from '../fn/group/free-table';
import { FreeTable$Params } from '../fn/group/free-table';
import { getGroup } from '../fn/group/get-group';
import { GetGroup$Params } from '../fn/group/get-group';
import { getGroupLayouts } from '../fn/group/get-group-layouts';
import { GetGroupLayouts$Params } from '../fn/group/get-group-layouts';
import { getGroups } from '../fn/group/get-groups';
import { GetGroups$Params } from '../fn/group/get-groups';
import { getTableShapeTypes } from '../fn/group/get-table-shape-types';
import { GetTableShapeTypes$Params } from '../fn/group/get-table-shape-types';
import { removeGroup } from '../fn/group/remove-group';
import { RemoveGroup$Params } from '../fn/group/remove-group';
import { tableHasBills } from '../fn/group/table-has-bills';
import { TableHasBills$Params } from '../fn/group/table-has-bills';
import { updateGroup } from '../fn/group/update-group';
import { UpdateGroup$Params } from '../fn/group/update-group';

@Injectable({ providedIn: 'root' })
export class GroupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getGroups()` */
  static readonly GetGroupsPath = '/api/groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroups$Response(params?: GetGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupsDto>> {
    return getGroups(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroups(params?: GetGroups$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoGroupGroupsDto> {
    return this.getGroups$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupsDto>): DigiworkMaitreDPosDtoGroupGroupsDto => r.body)
    );
  }

  /** Path part for operation `addGroup()` */
  static readonly AddGroupPath = '/api/groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addGroup$Response(params?: AddGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>> {
    return addGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addGroup(params?: AddGroup$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoGroupGroupDto> {
    return this.addGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>): DigiworkMaitreDPosDtoGroupGroupDto => r.body)
    );
  }

  /** Path part for operation `getGroup()` */
  static readonly GetGroupPath = '/api/groups/{servingAreaId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroup$Response(params: GetGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>> {
    return getGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroup(params: GetGroup$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoGroupGroupDto> {
    return this.getGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>): DigiworkMaitreDPosDtoGroupGroupDto => r.body)
    );
  }

  /** Path part for operation `updateGroup()` */
  static readonly UpdateGroupPath = '/api/groups/{servingAreaId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroup$Response(params: UpdateGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>> {
    return updateGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGroup(params: UpdateGroup$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoGroupGroupDto> {
    return this.updateGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupDto>): DigiworkMaitreDPosDtoGroupGroupDto => r.body)
    );
  }

  /** Path part for operation `removeGroup()` */
  static readonly RemoveGroupPath = '/api/groups/{servingAreaId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeGroup$Response(params: RemoveGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>> {
    return removeGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeGroup(params: RemoveGroup$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelSuccessfulResponse> {
    return this.removeGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelSuccessfulResponse>): DigiworkMaitreDApiConfigurationModelSuccessfulResponse => r.body)
    );
  }

  /** Path part for operation `getGroupLayouts()` */
  static readonly GetGroupLayoutsPath = '/api/groups/layouts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGroupLayouts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroupLayouts$Response(params?: GetGroupLayouts$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupsDto>> {
    return getGroupLayouts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGroupLayouts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGroupLayouts(params?: GetGroupLayouts$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoGroupGroupsDto> {
    return this.getGroupLayouts$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoGroupGroupsDto>): DigiworkMaitreDPosDtoGroupGroupsDto => r.body)
    );
  }

  /** Path part for operation `tableHasBills()` */
  static readonly TableHasBillsPath = '/api/groups/layouts/tables/{tableId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tableHasBills()` instead.
   *
   * This method doesn't expect any request body.
   */
  tableHasBills$Response(params: TableHasBills$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoGroupCanTableBeFreeDto>> {
    return tableHasBills(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tableHasBills$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tableHasBills(params: TableHasBills$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoGroupCanTableBeFreeDto> {
    return this.tableHasBills$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoGroupCanTableBeFreeDto>): DigiworkMaitreDPosDtoGroupCanTableBeFreeDto => r.body)
    );
  }

  /** Path part for operation `freeTable()` */
  static readonly FreeTablePath = '/api/groups/layouts/tables/{tableId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `freeTable()` instead.
   *
   * This method doesn't expect any request body.
   */
  freeTable$Response(params: FreeTable$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>> {
    return freeTable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `freeTable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  freeTable(params: FreeTable$Params, context?: HttpContext): Observable<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse> {
    return this.freeTable$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse>): DigiworkMaitreDApiConfigurationModelCustomResponsesSuccessfulActionResponse => r.body)
    );
  }

  /** Path part for operation `getTableShapeTypes()` */
  static readonly GetTableShapeTypesPath = '/api/groups/layouts/tables/shapes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTableShapeTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTableShapeTypes$Response(params?: GetTableShapeTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoEnumTypesEnumTypesDto>> {
    return getTableShapeTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTableShapeTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTableShapeTypes(params?: GetTableShapeTypes$Params, context?: HttpContext): Observable<DigiworkMaitreDPosDtoEnumTypesEnumTypesDto> {
    return this.getTableShapeTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<DigiworkMaitreDPosDtoEnumTypesEnumTypesDto>): DigiworkMaitreDPosDtoEnumTypesEnumTypesDto => r.body)
    );
  }

}
